import CardsFeature from './CardsFeature'
import ChatFeature from './ChatFeature'
import DashboardFeature from './DashboardFeature'
import IFrameFeature from './IFrameFeature'
import ListFeature from './ListFeature'
import PowerBiReportFeature from './PowerBiReportFeature'
import PowerBiDashboardFeature from './PowerBiDashboardFeature'
import TableFeature from './TableFeature'
import TreeFeature from './TreeFeature'
import TreeTableFeature from './TreeTableFeature'
import LinkFeature from './LinkFeature'
import GroupingFeature from './GroupingFeature'
import FeatureTabsFeature from './FeatureTabsFeature'
import GridDashboardFeature from './GridDashboardFeature'

import TimeSeriesFeature from './TimeSeriesFeature'
import EventsFeature from './EventsFeature'
import FilesFeature from './FilesFeature'
import InfoFeature from './InfoFeature'
import RelationsFeature from './RelationsFeature'
import HistoryFeature from './HistoryFeature'

import type { FeatureConfig } from 'src/models/FeatureConfig'

const featureConfigs: {
  [featureName: string]: FeatureConfig
} = {
  CardsFeature,
  ChatFeature,
  DashboardFeature,
  FilesFeature,
  EventsFeature,
  HistoryFeature,
  IFrameFeature,
  InfoFeature,
  ListFeature,
  PowerBiReportFeature,
  PowerBiDashboardFeature,
  RelationsFeature,
  TableFeature,
  TreeTableFeature,
  AdxTimeSeriesFeature: TimeSeriesFeature, //backwards compatibility
  TimeSeriesFeature,
  TreeFeature,
  LinkFeature,
  GroupingFeature,
  FeatureTabsFeature,
  GridDashboardFeature
}

export default featureConfigs
